import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { AgentsCategoriesProvider } from '../../providers/Agents/AgentsCategories/AgentsCategoriesProvider';
import { ArticlesHighlightsProvider } from '../../providers/Articles/ArticlesHighlights/ArticlesHighlightsProvider';
import { ArticlesProvider } from '../../providers/Articles/ArticlesProvider';
import { ArticleCommentProvider } from '../../providers/Articles/ArticlesCommentsProvider';

interface Props {
    element?: any;
    path?: string;
}

export const AppHomeRoute: FC<Props> = () => {
    return (
        <AgentsCategoriesProvider>
            <ArticlesHighlightsProvider>
                <ArticlesProvider>
                    <ArticleCommentProvider>
                        <Outlet />
                    </ArticleCommentProvider>
                </ArticlesProvider>
            </ArticlesHighlightsProvider>
        </AgentsCategoriesProvider>
    );
}